// extracted by mini-css-extract-plugin
module.exports = {"block":"SpeakersSlider_block__1uXAF","header":"SpeakersSlider_header__3_UDe","title":"SpeakersSlider_title__2nX3Y","link":"SpeakersSlider_link__1pqHG"};